import { Box, useTheme } from '@mui/material';

function DayContainer({ cellDate, children, onClick, isToday }) {
  const theme = useTheme();
  return (
    <Box
      {...(onClick
        ? {
            onClick: () => onClick?.(cellDate),
            role: 'button',
          }
        : {})}
      sx={{
        minHeight: 120,
        p: 0.75,
        borderRadius: 1,
        cursor: onClick ? 'pointer' : 'default',
        bgcolor: 'transparent',
        border: isToday
          ? `2px solid ${theme.palette.warning.main}`
          : `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        ...(onClick
          ? {
              '&:hover': {
                outline: `1px solid ${theme.palette.divider}`,
              },
            }
          : {}),
      }}>
      {children}
    </Box>
  );
}

export default DayContainer;
